// src/aws-config.js

// Detectar el entorno actual
const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

const currentUrl = window.location.origin + '/';

export const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-2_1sbHBIk5J',
      userPoolClientId: '600cp2hms87bjlngl38ort3r06', // ✅ Nuevo Client ID SPA
      region: 'us-east-2',
      loginWith: {
        oauth: {
          domain: 'us-east-21sbhbik5j.auth.us-east-2.amazoncognito.com',
          scopes: ['email', 'openid', 'phone'],
          redirectSignIn: [currentUrl],
          redirectSignOut: [currentUrl],
          responseType: 'code',
          additionalParameters: {
            lang: 'es'
          }
        }
      }
    }
  }
};

// Debug: Mostrar la configuración completa
//console.log('🔧 Configuración completa de AWS:', JSON.stringify(awsConfig, null, 2));

//console.log('AWS Config - Entorno detectado:', isLocalhost ? 'Development' : 'Production');
//console.log('AWS Config - URL de redirect:', currentUrl);

// 🔍 DEBUG: Mostrar parámetros de la URL cuando regresamos de Cognito
if (window.location.search) {
  //console.log('🔍 DEBUG - Parámetros de URL completos:', window.location.search);
  //console.log('🔍 DEBUG - URL completa:', window.location.href);
  
  const urlParams = new URLSearchParams(window.location.search);
  //console.log('🔍 DEBUG - Parámetros individuales:');
  for (let [key, value] of urlParams) {
    //console.log(`  ${key}: ${value}`);
  }
} 